export default "__VITE_ASSET__B8kmus3k__"